import { modelsCompFn } from '@/lib/filter/base-frontend-filter/scope';

export const directRelationFn = ({ entity, scope }) => {
  let key = scope.directProperty.edgeName;
  if (scope.directProperty.edgeAlias !== undefined && scope.directProperty.edgeAlias !== '') {
    key = scope.directProperty.edgeAlias;
  }
  const models = entity[key];
  const neededModels = scope.relation ? [scope.relation] : [];
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};
